import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import Select from '../../../_shared/components/Select';
import PaymentsOnHoldContext from '../Context';
import { Wrapper, DataBox, SpanBlack, DataBoxBlock } from './Styles';

const SummaryBox = () => {
  const intl = useIntl();
  const {
    summary: { amountOnHold, totalNumberOfTrades, requirements },
    metadata: {
      sortDefinitions: { inputs: sorting }
    },
    sortSelected,
    onSortTrades
  } = useContext(PaymentsOnHoldContext);

  const sortOptions = (sorting || []).map(({ key, value }) => ({
    id: `${key}`,
    value: key,
    label: value
  }));

  return (
    <Wrapper>
      <DataBox data-testid="payments-on-hold-databox">
        <DataBoxBlock data-testid="payments-on-hold-databox-totalAmountOnHold">
          {intl.formatMessage({ id: 'paymentsOnHold.totalAmountOnHold' })}
          &nbsp;
          {Number.isInteger(totalNumberOfTrades) && (
            <SpanBlack
              isBald
              data-testid="payments-on-hold-databox-totalAmountOnHold-amount"
            >
              {amountOnHold} (
              {intl.formatMessage(
                { id: 'list.header.amount.vehicles' },
                { amount: totalNumberOfTrades }
              )}
              )
            </SpanBlack>
          )}
        </DataBoxBlock>
        <DataBoxBlock data-testid="payments-on-hold-databox-ownershipsOwing">
          {intl.formatMessage({ id: 'paymentsOnHold.ownershipsOwing' })}
          &nbsp;
          <SpanBlack data-testid="payments-on-hold-databox-ownershipsOwing-amount">
            {requirements[2]?.totalNumberOfTrades}
          </SpanBlack>
        </DataBoxBlock>
        <DataBoxBlock data-testid="payments-on-hold-databox-lienReleasesOwing">
          {intl.formatMessage({ id: 'paymentsOnHold.lienReleasesOwing' })}
          &nbsp;
          <SpanBlack data-testid="payments-on-hold-databox-lienReleasesOwing-amount">
            {requirements[1]?.totalNumberOfTrades}
          </SpanBlack>
        </DataBoxBlock>
      </DataBox>
      {sorting?.length && (
        <Select
          options={sortOptions}
          defaultValue={sortSelected}
          className="sortTrades"
          onChange={onSortTrades}
        >
          {intl.formatMessage({ id: 'list.sorting.label' })}
        </Select>
      )}
    </Wrapper>
  );
};

export default SummaryBox;
